// extracted by mini-css-extract-plugin
export default {"product":"Post_product__71NTc","filter":"Post_filter__RHvHI","content":"Post_content__28+2o","icon":"Post_icon__F9-Ih","show":"Post_show__emtLW"};